import React from "react"

import Layout from "../components/common/layout/layout"
import SEO from "../components/common/layout/seo"
import Navigation from "../components/common/navigation/navigation"
import styled from "styled-components"
import Footer from "../components/sections/footer"
import { FLATICON_URL, FREEPIK_URL } from "../utils"

const CreditsPage = () => (
  <Layout>
    <SEO title="Credits" />
    <Navigation />
    <CreditsContent>
      <h1>Credits</h1>
      <Content>
        <p>
          Some of the icons used on this site come from{" "}
          <a href={FLATICON_URL} target="_blank" rel="noopener noreferrer">
            FlatIcon
          </a>
          . They are used under the license :
          <em> Premium license (Unlimited use without attribution)</em>
        </p>
        <p>
          Special credits to{" "}
          <a href={FREEPIK_URL} target="_blank" rel="noopener noreferrer">
            Freepik
          </a>{" "}
          for the great icons
        </p>
      </Content>
    </CreditsContent>
    <Footer />
  </Layout>
)

const CreditsContent = styled.header`
  background-color: ${props => props.theme.color.background.light};
  padding: 80px 16px 80px 16px;
  position: relative;
  text-align: center;
  height: 100vh;

  @media (max-width: ${props => props.theme.screen.sm}) {
    padding: 80px 16px 40px 16px;
  }

  > h1 {
    ${props => props.theme.font_size.large}
  }

  h2 {
    ${props => props.theme.font_size.regular}
  }
`

const Content = styled.div`
  text-align: justify;
`

export default CreditsPage
